export default {
  parent_id: null,
  name: null,
  description: null
}